export default "__VITE_ASSET__a71bee25__"